import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";

@Pipe({
  name: "noOnlinePaymentNoPickupOnly",
})
export class NoOnlinePaymentNoPickupOnlyPipe implements PipeTransform {
  transform(array: any): any[] {
    return _.filter(array, {
      onlinePaymentOnly: false,
      pickupOnly: false,
    });
  }
}
